// import { axInst } from "../Login/Service.jsx";

// //region
// export const fetchRegion = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.REGION.buckets.map((e) => e.key);
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// export const fetchNewRegion = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.NEW_REGION.buckets.map((e) => e.key);
//   // console.log("NEW REGIONS ARRAY", regionsArray)
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// export const fetchRM = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.RM.buckets.map((e) => e.key);
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// export const fetchAreaManager = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.AREA_MANAGER.buckets.map((e) => e.key);
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// export const fetchAreaOffice = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.AREA_OFFICE.buckets.map((e) => e.key);
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// export const fetchTsmName = async () => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });

//   const regionsArray = data?.TSM_NAME.buckets.map((e) => e.key);
//   const sortedRegionArray = regionsArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedRegionArray;
// };

// //DealerCode
// export const fetchDealercode = async (
//   pRegion,
//   pState,
//   pStateOffice,
//   pPartnerType,
//   pDealer
// ) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: pStateOffice || [],
//     Partner_Type: pPartnerType || [],
//     dealer_name: pDealer || [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//   });
//   const dealercodeArray = data?.DEALER_CODE.buckets.map((e) => e.key);
//   const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sorteddealercodeArray;
// };

// //DealerName
// export const fetchDealer = async (
//   pRegion,
//   pState,
//   pStateOffice,
//   pPartnerType
// ) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: pStateOffice || [],
//     Partner_Type: pPartnerType || [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//   });
//   const DealerArray = data?.DEALER_NAME.buckets.map((e) => e.key);
//   const sortedDealerArray = DealerArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedDealerArray;
// };

// export const fetchPartnerType = async (pRegion, pState, pStateOffice) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: pStateOffice || [],
//     Partner_Type: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//   });

//   const PartnerTypeArray = data?.PARTNER_TYPE.buckets.map((e) => e.key);
//   const sortedPartnerTypeArray = PartnerTypeArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedPartnerTypeArray;
// };

// //state
// export const fetchStates = async (pRegion) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });
//   const statesArray = data?.STATE.buckets.map((e) => e.key);
//   const sortedStatesArray = statesArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedStatesArray;
// };

// //stateoffice
// export const fetchStatesOffice = async (pRegion, pState) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });
//   const statesOfficeArray = data?.STATE_OFFICE.buckets.map((e) => e.key);
//   const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedStatesOfficeArray;
// };

// export const fetchNewState = async (pRegion, pState) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });
//   const statesOfficeArray = data?.NEW_STATE.buckets.map((e) => e.key);
//   const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedStatesOfficeArray;
// };

// export const fetchProductLine = async (
//   pRegion,
//   pState,
//   pStateOffice,
//   pPartnerType,
//   pDealer,
//   pDealerCode
// ) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: pStateOffice || [],
//     Partner_Type: pPartnerType || [],
//     dealer_name: pDealer || [],
//     dealer_code: pDealerCode || [],
//     Product_Line: [],
//     lob: [],
//     Partner_Type: [],
//   });
//   const productLineArray = data?.PRODUCT_LINE.buckets.map((e) => e.key);

//   const sortedProductLineArray = productLineArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );
//   return sortedProductLineArray;
// };

// //Lob
// export const fetchLOB = async (
//   pRegion,
//   pState,
//   pStateOffice,
//   pPartnerType,
//   pDealer,
//   pDealerCode,
//   pProductLine
// ) => {
//   const { data } = await axInst.post("dealer-review/manpower_new_filter", {
//     region: pRegion || [],
//     state: pState || [],
//     state_office: pStateOffice || [],
//     Partner_Type: pPartnerType || [],
//     dealer_name: pDealer || [],
//     dealer_code: pDealerCode || [],
//     Product_Line: pProductLine || [],
//     lob: [],
//   });

//   const lobArray = data?.LOB.buckets.map((e) => e.key);
//   const sortedLobArray = lobArray.sort((a, b) =>
//     ("" + a).localeCompare(b, undefined, { numeric: true })
//   );

//   return sortedLobArray;
// };

import { axInst } from "../Login/Service.jsx";

/**
 * Generic helper to fetch filtered data for any dropdown.
 * @param {Object} filters - The current selections from Redux.
 * @param {string} targetKey - The key in the API response (e.g., 'REGION', 'STATE').
 */
const fetchFilterData = async (filters, targetKey) => {
  const payload = {
    region: filters.region || [],
    new_region: filters.new_region || [],
    state: filters.state || [],
    new_state: filters.new_state || [],
    state_office: filters.state_office || [],
    dealer_name: filters.dealer_name || [],
    dealer_code: filters.dealer_code || [],
    Product_Line: filters.Product_Line || [],
    lob: filters.lob || [],
    Partner_Type: filters.Partner_Type || [],
    rm: filters.rm || [],
    area_manager: filters.area_manager || [],
    area_office: filters.area_office || [],
    tsm_name: filters.tsm_name || [],
  };

  const { data } = await axInst.post(
    "dealer-review/manpower_new_filter",
    payload,
  );

  // Extract buckets from the specific key provided
  const buckets = data?.[targetKey]?.buckets || [];

  return buckets
    .map((e) => e.key)
    .sort((a, b) => ("" + a).localeCompare(b, undefined, { numeric: true }));
};

// Exported functions used by useQuery
export const fetchRegion = (f) => fetchFilterData(f, "REGION");
export const fetchNewRegion = (f) => fetchFilterData(f, "NEW_REGION");
export const fetchRM = (f) => fetchFilterData(f, "RM");
export const fetchAreaManager = (f) => fetchFilterData(f, "AREA_MANAGER");
export const fetchAreaOffice = (f) => fetchFilterData(f, "AREA_OFFICE");
export const fetchTsmName = (f) => fetchFilterData(f, "TSM_NAME");
export const fetchStates = (f) => fetchFilterData(f, "STATE");
export const fetchNewState = (f) => fetchFilterData(f, "NEW_STATE");
export const fetchStatesOffice = (f) => fetchFilterData(f, "STATE_OFFICE");
export const fetchPartnerType = (f) => fetchFilterData(f, "PARTNER_TYPE");
export const fetchDealer = (f) => fetchFilterData(f, "DEALER_NAME");
export const fetchDealercode = (f) => fetchFilterData(f, "DEALER_CODE");
export const fetchProductLine = (f) => fetchFilterData(f, "PRODUCT_LINE");
export const fetchLOB = (f) => fetchFilterData(f, "LOB");
